import { useContext } from 'react';
import ConfigurationsContext from '../contexts/configurations.context';

const useConfigurations = () => {
    return useContext(ConfigurationsContext);
};

export default useConfigurations;